/* eslint-disable @nx/enforce-module-boundaries */
import { ComponentStyleConfig } from '@chakra-ui/react';

export const Button: ComponentStyleConfig = {
  baseStyle: {
    lineHeight: '1.2',
    borderRadius: 'md',
    fontWeight: 'semibold',
    transitionProperty: 'common',
    transitionDuration: 'normal',
    _focusVisible: {
      boxShadow: 'outline',
    },
    _disabled: {
      cursor: 'not-allowed',
      boxShadow: 'none',
    },
    _hover: {
      _disabled: {
        bg: 'initial',
      },
    },
  },
  variants: {
    primary: {
      bg: 'accent.default',
      color: 'white',
      _hover: {
        bg: 'accent.hover',
        _disabled: {
          bg: 'accent.disabled',
        },
      },
      _focusVisible: {
        bg: 'accent.hover',
      },
      _disabled: {
        opacity: 1,
        color: 'white',
        bg: 'accent.disabled',
      },
      _active: { bg: 'accent.pressed' },
    },
    secondary: {
      bg: 'white',
      color: 'text.secondary',
      border: '1px solid',
      borderColor: 'stroke.grey',
      boxShadow: 'sm',
      _hover: {
        bg: 'blackAlpha.40',
        _disabled: {
          bg: 'white',
        },
      },
      _focusVisible: {
        bg: 'white',
        borderColor: 'accent.default',
        color: 'accent.default',
      },
      _disabled: {
        opacity: 1,
        color: 'text.quaternary',
      },
      _active: {
        bg: 'blackAlpha.80',
      },
    },
    auxiliary: {
      bg: 'transparent',
      color: 'text.tertiary',
      _hover: {
        bg: 'blackAlpha.40',
        color: 'text.secondary',
        _disabled: {
          bg: 'transparent',
          color: 'text.quaternary',
        },
      },
      _focusVisible: {
        bg: 'blackAlpha.40',
        color: 'accent.default',
      },
      _disabled: {
        opacity: 1,
        color: 'text.quaternary',
      },
      _active: { bg: 'blackAlpha.80', color: 'text.secondary' },
    },
    'no-padding': {
      p: '0',
      m: '0',
      bg: 'none',
      lineHeight: 'normal',
      color: 'text.tertiary',
      _hover: {
        color: 'text.secondary',
        _disabled: {
          color: 'text.quaternary',
        },
      },
      _focusVisible: {
        color: 'accent.default',
      },
      _disabled: {
        opacity: 1,
        color: 'text.quaternary',
      },
      _active: {
        color: 'text.secondary',
      },
    },
    destructive: {
      bg: 'error.default',
      color: 'white',
      _hover: {
        bg: 'error.hover',
        _disabled: {
          bg: 'error.disabled',
        },
      },
      _focusVisible: {
        bg: 'error.hover',
      },
      _disabled: {
        opacity: 1,
        bg: 'error.disabled',
      },
      _active: { bg: 'error.pressed' },
    },
  },
  sizes: {
    md: {
      h: '34px',
      minW: '8',
      fontSize: 'md',
      px: '4',
    },
    sm: {
      h: '26px',
      minW: '6',
      fontSize: 'sm',
      px: '3',
    },
  },
};
